import { motion } from "framer-motion";
import { BeforeAfter } from "@/components/site/BeforeAfter";
import { GALLERY } from "@/lib/content";

export default function Gallery() {
  return (
    <section id="gallery" className="relative bg-black py-24 md:py-32 border-t border-white/10" data-testid="gallery-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="mb-12 md:mb-16 flex flex-col md:flex-row md:items-end md:justify-between gap-4"
        >
          <div>
            <p className="mb-6 text-xs uppercase tracking-mega text-gold">The Difference</p>
            <h2 className="font-serif font-light text-4xl md:text-6xl text-white tracking-tight leading-[0.95]">
              Before &amp; After
            </h2>
          </div>
          <p className="max-w-sm text-sm font-light text-white/50 leading-relaxed">
            Drag the slider on each panel to see the transformation. This is the standard on every job.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {GALLERY.map((g, i) => (
            <motion.div
              key={g.label}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
            >
              <BeforeAfter image={g.image} label={g.label} />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
